export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-tab-bar/index.js